import styled from 'styled-components';

import { variables } from '../../../styles/variables';

const MaintenanceModePageWrapper = styled.div`
  width: 100%;
  .header {
    width: 100%;
    height: auto;
    border-bottom: 4px solid ${variables.colorDecorator};

    img {
      margin: 0 0 16px 32px;
    }
  }

  .content {
    margin: 32px;

    img {
      margin: 32px 0;
    }

    h1 {
      font-size: 40px;
      font-weight: 700;
    }

    h2 {
      font-size: 24px;
      margin-bottom: 64px;
      font-weight: 700;
    }

    h3 {
      font-size: 20px;
    }

    h4 {
      margin: 0;

      &.withBold {
        font-weight: 700;
      }
    }

    h5 {
      font-size: 12px;
      margin: 0 0 0 8px;
      display: inline-block;
    }
    ul {
      list-style: disc;
      padding-left: 2.5rem;
      font-size: 2.4rem;
    }
    p {
      margin: 0;
    }
  }
`;

export {
  MaintenanceModePageWrapper,
};